// src/stores/useOnboardingStore.js
import { defineStore } from "pinia";

/**
 * Store em memória para persistir o estado do fluxo de onboarding
 * entre o UserRegistrationForm e o UpgradePage.
 * Não usa localStorage — dados vivem apenas na sessão atual.
 */
export const useOnboardingStore = defineStore("onboarding", {
  state: () => ({
    // 'Individual' | 'Family' | 'Edu' | null
    usageType: null,
    // Nome da instituição digitado no cadastro de escola. Só existe nesta
    // store (estado de sessão/UI) — não há coluna correspondente no backend,
    // nunca é enviado em nenhum payload de API.
    institutionName: null,
  }),

  getters: {
    isFamily: (state) => state.usageType === "Family",
    isEdu: (state) => state.usageType === "Edu",
    isIndividual: (state) => state.usageType === "Individual",
    requiresPayment: (state) =>
      state.usageType === "Family" || state.usageType === "Edu",
  },

  actions: {
    setUsageType(type) {
      this.usageType = type;
    },
    setInstitutionName(name) {
      this.institutionName = name;
    },
    reset() {
      this.usageType = null;
      this.institutionName = null;
    },
  },
});
